import React from "react";
import TrunkHeaderImg1 from "../../../../assets/images/trunk/csth1.jpeg";
import TrunkHeaderImg2 from "../../../../assets/images/trunk/csth2.jpeg";
import TrunkHeaderImg3 from "../../../../assets/images/trunk/csth3.jpeg";
import { ITrunkDetailItem } from "interfaces/ClientInterface/PerlickClientInterface/ICHOrder";

interface TrunkHeadDiagramProps {
  trunkDetailData: ITrunkDetailItem[];
}

const TrunkHeadDiagram: React.FC<TrunkHeadDiagramProps> = ({ trunkDetailData }) => {
  const noheads = trunkDetailData?.[0]?.noheads ?? 0;
  const uninsulated = trunkDetailData?.[0]?.uninsulated ?? "";
  const lentotee = trunkDetailData?.[0]?.lentotee ?? "";

  const getTrunkHeadInfo = (i: number) => (trunkDetailData?.[i] ? [trunkDetailData[i]] : []);

  const headCells: React.ReactNode[] = [];

  for (let i = 1; i <= noheads - 1; i++) {
    const results = getTrunkHeadInfo(i);
    const result = results[0] ?? {};

    const { lentonext = 0, lentohd = 0 } = result;

    headCells.push(
      <td key={`head-${i}`}>
        <div style={{ position: "relative", display: "inline-block" }}>
          <img src={TrunkHeaderImg2} alt={`Head ${i}`} />
          <input
            type="text"
            disabled
            name={`lentohda[${i}]`}
            value={lentohd}
            style={{
              position: "absolute",
              left: "37px",
              top: "30px",
              width: "20px",
            }}
          />
          <input
            type="text"
            disabled
            name={`lentonexta[${i}]`}
            value={lentonext}
            style={{
              position: "absolute",
              left: "50px",
              top: "93px",
              width: "30px",
            }}
          />
          <p
            style={{
              position: "absolute",
              left: "40px",
              top: "0px",
              fontSize: "9pt",
            }}
          >
            Head {i}
          </p>
        </div>
      </td>
    );
  }

  return (
    <table
      cellSpacing={0}
      border={0}
      cellPadding={0}
      className="parameter-picture"
      style={{ display: "inline-block" }}
    >
      <tbody>
        <tr>
          {/* Start of Trunk */}
          <td>
            <div style={{ position: "relative", display: "inline-block" }}>
              <img src={TrunkHeaderImg1} alt="Trunk Start" />
              <input
                type="text"
                disabled
                name="uninsulated"
                value={uninsulated}
                style={{
                  position: "absolute",
                  left: "32px",
                  top: "93px",
                  width: "50px",
                }}
              />
              <input
                type="text"
                disabled
                name="lentotee"
                value={lentotee}
                style={{
                  position: "absolute",
                  left: "105px",
                  top: "93px",
                  width: "50px",
                }}
              />
            </div>
          </td>

          {/* Intermediate heads */}
          {headCells}

          {/* Final head */}
          <td>
            <div style={{ position: "relative" }}>
              <img src={TrunkHeaderImg3} alt="End Head" height="120px" />
              <p
                style={{
                  position: "absolute",
                  left: "10px",
                  top: "28px",
                  fontSize: "9pt",
                }}
              >
                Head {noheads}
              </p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default TrunkHeadDiagram;
